var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.827473 0.163967C0.91946 0.0692605 1.04292 0.0114852 1.17457 0.00153765C1.30622 -0.00840988 1.43697 0.0301579 1.54214 0.109967L1.60347 0.163967L6.00014 4.64863L10.3968 0.163967C10.4888 0.0692605 10.6123 0.0114852 10.7439 0.00153765C10.8756 -0.00840988 11.0063 0.0301579 11.1115 0.109967L11.1728 0.163967C11.266 0.259747 11.3224 0.385314 11.3322 0.518588C11.3419 0.651861 11.3044 0.784307 11.2261 0.892634L11.1728 0.955301L6.38814 5.83597C6.29615 5.93067 6.17269 5.98845 6.04104 5.9984C5.90939 6.00835 5.77865 5.96978 5.67347 5.88997L5.61214 5.83597L0.827473 0.955301C0.724557 0.849302 0.666992 0.707375 0.666992 0.559634C0.666992 0.411893 0.724557 0.269966 0.827473 0.163967Z",
    fill: "#71859E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.ee522434cb49d8c42e0f571d51c6f86c.svg";
export { ForwardRef as ReactComponent };